module.exports = __webpack_public_path__ + "res/ic_square.a5d6c4e5ed2f34b0595ec53c8cf71148.png";